import React from 'react';
import { Typography } from 'antd';
import EnhancedRackDevice from './EnhancedRackDevice';
import { resolveDiagramTemplate, getTemplateLabel, getDiagramConfig } from './utils';

const { Title, Text } = Typography;

const RackDeviceVisualization = ({ device, ports = [] }) => {
  if (!device) return null;

  const template = resolveDiagramTemplate(device);
  const templateLabel = getTemplateLabel(template);
  const diagramConfig = getDiagramConfig(device);
  const connectedPortIds = new Set();

  ports.forEach((port) => {
    if (port.connected_portregistry) {
      connectedPortIds.add(String(port._id));
      const targetId =
        typeof port.connected_portregistry === 'object'
          ? port.connected_portregistry._id
          : port.connected_portregistry;
      if (targetId) connectedPortIds.add(String(targetId));
    }
  });

  return (
    <div
      className="rack-device-visualization"
      style={{
        marginTop: 24,
        padding: 16,
        background: '#f8f9fa',
        border: '1px solid #e9ecef',
        borderRadius: 8,
      }}
    >
      <Title level={4} style={{ marginTop: 0 }}>
        Rack Visualization
      </Title>
      <Text type="secondary" style={{ display: 'block', marginBottom: 12 }}>
        Device faceplate based on equipment model settings
        {device.deviceregistry
          ? ` · ${ports.length} port registry row${ports.length !== 1 ? 's' : ''}`
          : ' · link Device Registry to show registered ports'}
      </Text>
      <div
        style={{
          border: '2px solid #1890ff',
          borderRadius: 6,
          padding: '12px 14px',
          background: '#fff',
        }}
      >
        <div
          style={{
            marginBottom: 10,
            padding: '6px 10px',
            background: '#e6f4ff',
            borderRadius: 4,
            border: '1px solid #91d5ff',
            fontWeight: 600,
            fontSize: 13,
          }}
        >
          {device.equipment_name}{' '}
          <span style={{ fontWeight: 400, color: '#595959' }}>
            ({templateLabel}
            {device.number_of_u ? ` · ${device.number_of_u}U` : ''})
          </span>
        </div>
        <EnhancedRackDevice
          deviceRecord={device}
          ports={ports}
          selectedPortId={null}
          connectedPortIds={connectedPortIds}
          readOnly
        />
        {template === 'switch-48-sfp' && (
          <Text
            type="secondary"
            style={{ display: 'block', marginTop: 10, fontSize: 11 }}
          >
            Layout: {diagramConfig.portCount} ports in {diagramConfig.portRows}{' '}
            row(s), {diagramConfig.sfpCount} SFP in {diagramConfig.sfpRows}{' '}
            row(s), top row{' '}
            {diagramConfig.topRowNumbering === 'odd' ? 'odd' : 'even'} numbers
          </Text>
        )}
      </div>
    </div>
  );
};

export default RackDeviceVisualization;
